const SMALL_AND_BELOW = 767;
const MEDIUM_AND_BELOW = 990;
const LARGE_AND_BELOW = 1199;

const SMALL_AND_ABOVE = 768;
const MEDIUM_AND_ABOVE = 991;
const LARGE_AND_ABOVE = 1200;

const MOBILE_CONTACT_INFO = 990;

export default {
  SMALL_AND_BELOW,
  MEDIUM_AND_BELOW,
  LARGE_AND_BELOW,
  SMALL_AND_ABOVE,
  MEDIUM_AND_ABOVE,
  LARGE_AND_ABOVE,
  MOBILE_CONTACT_INFO,
};



// WEBPACK FOOTER //
// ./src/css/breakpoints.js